<template>
  <div style="background-color: #f7f8fa; height: 100%;">
    <van-nav-bar title="我的查询" left-text="返回" right-text="" @click-left="onClickLeft"/>
    <van-tabs sticky @click="tabClick">
      <van-tab title="打卡记录">
        <van-empty description="暂无数据" v-if="emptyShowOne"/>
        <van-cell-group class="cus-card" v-for="item in userAttenceRecordList" :key="item.id">
          <van-cell title="日期" :value="dateFormat(item.cardTime)"/>
          <van-cell title="打卡时间" :value="item.cardTime"/>
          <van-cell title="设备名称" :value="item.fixAddr"/>
          <van-cell title="认证方式" :value="checkTypeFormat(item.checkType)"/>
        </van-cell-group>
      </van-tab>
      <van-tab title="考勤结果">
        <van-empty description="暂无数据" v-if="emptyShowTwo"/>
        <van-cell-group class="cus-card" v-for="item in attendanceInfoList" :key="item.id">
          <van-cell title="日期" :value="item.workingTime"/>
          <van-cell title="上班时间" :value="item.attendanceBeginTime"/>
          <van-cell title="下班时间" :value="item.attendanceEndTime"/>
          <van-cell title="时段信息" :value="item.timeQuantumMsg"/>
          <van-cell title="考勤结果" :value="item.attendanceResult"/>
        </van-cell-group>
      </van-tab>
      <van-tab title="异常考勤">
        <van-empty description="暂无数据" v-if="emptyShowThree"/>
        <van-cell-group class="cus-card" v-for="item in errorAttendanceInfoList" :key="item.id">
          <van-cell title="日期" :value="item.workingTime"/>
          <van-cell title="上班时间" :value="item.attendanceBeginTime"/>
          <van-cell title="下班时间" :value="item.attendanceEndTime"/>
          <van-cell title="时段信息" :value="item.timeQuantumMsg"/>
          <van-cell title="考勤结果" :value="item.attendanceResult"/>
        </van-cell-group>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import {isLogin, isWechat} from "../../../utils/util";

export default {
  name: "list",
  data() {
    return {
      emptyShowOne: false,
      emptyShowTwo: false,
      emptyShowThree: false,
      userAttenceRecordList: [],
      authorCheckType: [],
      attendanceInfoList: [],
      errorAttendanceInfoList: [],
    }
  },
  mounted() {
    if (!isLogin()) {
      this.$router.push({
        path: "/attenceflow/Error",
        query: {}
      });
    }
    this.initData();
  },
  methods: {
    initData() {
      this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
        code: 'author_check_type'
      }).then(res => {
        const data = res.data;
        this.authorCheckType = data;
        this.getUserAttenceRecordList();
      });
    },
    tabClick(name, title) {
      if (title == '打卡记录') {
        this.getUserAttenceRecordList();
      } else if (title == '考勤结果') {
        this.getAttendanceInfoList();
      } else if (title == '异常考勤') {
        this.getErrorAttendanceInfoList();
      }
    },
    onClickLeft: function () {
      this.$router.push({
        path: "/attenceflow/AttenceHome",
        query: {}
      });
    },
    getUserAttenceRecordList() {
      this.emptyShowOne = false;
      this.$fetch("/attence-api/blade-manager/userAttenceRecord/myAttenceRecord", {
        days: 30
      }).then(res => {
        const data = res.data;
        this.userAttenceRecordList = data;
        if (this.userAttenceRecordList.length == 0) {
          this.emptyShowOne = true;
        }
      });
    },
    getAttendanceInfoList() {
      this.emptyShowTwo = false;
      this.$fetch("/attence-api/blade-attendance-info/attendanceInfo/myAttendanceInfo", {
        days: 30
      }).then(res => {
        const data = res.data;
        this.attendanceInfoList = data;
        if (this.attendanceInfoList.length == 0) {
          this.emptyShowTwo = true;
        }
      });
    },
    getErrorAttendanceInfoList() {
      this.emptyShowThree = false;
      this.$fetch("/attence-api/blade-attendance-info/attendanceInfo/myErrorAttendanceInfo", {
        days: 30
      }).then(res => {
        const data = res.data;
        this.errorAttendanceInfoList = data;
        if (this.errorAttendanceInfoList.length == 0) {
          this.emptyShowThree = true;
        }
      });
    },
    dateFormat(date) {
      return date.split(' ')[0];
    },
    checkTypeFormat(type) {
      let typeVal = '';
      this.authorCheckType.forEach(v => {
        if (type == v.dictKey) {
          typeVal = v.dictValue;
        }
      });
      return typeVal;
    }
  },
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

.cus-card {
  margin: 16px 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/query/list.vue